import { compactMoney } from "../../../utils/directorFormat";

// Cartões de indicador das telas da Diretoria, no cartão comum `ampli-summary-card`.
// Cada cartão: `{ key, label, value | cents, note, tone, onClick, pressed }`. Com `cents`, o valor
// sai em reais compactos e o exato vai no `title`. Com `onClick`, o cartão é um botão (filtro).
const TONES = new Set(["neutral", "good", "pressure", "warning", "info"]);

const DirectorSummaryCards = ({ cards = [], label = "Indicadores" }) => {
  const visible = cards.filter(Boolean).slice(0, 4);
  if (visible.length === 0) return null;
  return <section className="ampli-summary-grid director-summary-grid" aria-label={label}>
    {visible.map((card) => {
      const money = card.cents !== undefined ? compactMoney(card.cents) : null;
      const tone = TONES.has(card.tone) ? card.tone : "neutral";
      const content = <>
        <span>{card.label}</span>
        <strong title={money?.title ?? card.title ?? undefined}>{money ? money.text : card.value}</strong>
        {card.note && <small>{card.note}</small>}
      </>;
      const className = `ampli-summary-card ampli-summary-card--${tone}`;
      return card.onClick
        ? <button
          key={card.key}
          type="button"
          className={className}
          aria-pressed={card.pressed === undefined ? undefined : (card.pressed ? "true" : "false")}
          onClick={card.onClick}
        >{content}</button>
        : <article key={card.key} className={className}>{content}</article>;
    })}
  </section>;
};

export default DirectorSummaryCards;
